import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function LogoMarquee({ coords }) {
  const [items, setItems] = useState([]);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const q = coords ? `?lat=${coords.lat}&lng=${coords.lng}` : "";
    api.get(`/logos${q}`).then((r) => setItems(r.data)).catch(() => {});
  }, [coords?.lat, coords?.lng]);

  if (!items.length) return null;
  const reps = Math.max(1, Math.ceil(6 / items.length));
  const base = Array.from({ length: reps }, () => items).flat();
  const hold = () => setPaused(true);
  const release = () => setPaused(false);

  return (
    <section className="mt-5 overflow-hidden select-none" data-testid="logo-marquee"
      style={{ touchAction: "pan-y" }}
      onPointerDown={hold} onPointerUp={release} onPointerLeave={release} onPointerCancel={release}
      onContextMenu={(e) => e.preventDefault()}>
      <div className="gs-marquee flex w-max" style={{ animationDuration: `${base.length * 2.5}s`, animationPlayState: paused ? "paused" : "running" }}>
        {[0, 1].map((k) => (
          <div key={k} className="flex gap-2 pr-2 py-1" aria-hidden={k === 1}>
            {base.map((it, i) => (
              <div key={`${k}-${i}`} data-testid={k === 0 ? `marquee-logo-${i}` : undefined} title={it.title}
                className="w-16 h-16 rounded-xl bg-white shadow-md border border-slate-100 overflow-hidden shrink-0">
                <img src={it.logo} alt={it.title} draggable={false} loading="lazy" className="w-full h-full object-cover pointer-events-none" style={{ transform: `scale(${Number(it.logo_scale) || 1})` }} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default LogoMarquee;
